module.exports = __webpack_public_path__ + "img/888dac6.png";